module.exports = __webpack_public_path__ + "media/images/players/GOOCH_TALOR-81b19afda2018e8341634305640e9807.png";